// extracted by mini-css-extract-plugin
export default {"label":"season_group_select__label--idhX"};